import { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import { sanitizeHtmlContent } from 'src/utils';

import { parse, Allow } from 'partial-json';
import {
  startStreamSummary,
  endSummaryStream,
} from '../../utils/summary_stream';
import './SummaryStreamingInProgress.scss';

export const SummaryStreamingInProgress = ({
  encounter_id,
  encounter_phase,
}) => {
  const [summary, setSummary] = useState('');

  const onSummary = (data) => {
    if (data) {
      setSummary(data);
    }
  };

  const onToken = (data) => {
    if (data?.token) {
      setSummary((prevSummary) => prevSummary + data?.token);
    }
  };

  useEffect(() => {
    startStreamSummary(encounter_id, encounter_phase, onSummary, onToken);

    // Cleanup function to end the summary stream when component unmounts
    return () => {
      endSummaryStream(encounter_id);
    };
  }, [encounter_id, encounter_phase]);

  const parseSummary = (summary) => {
    if (summary) {
      const parsedSummary = parse(summary, Allow.ALL);
      return parsedSummary;
    }
  };

  const formatParsedSummary = (parsedSummary) => {
    if (parsedSummary?.sections) {
      return Object.entries(parsedSummary.sections)
        .map(([section, content]) => {
          // Replace all newline characters with <br/> tags
          const formattedContent = content.replace(/\n/g, '<br>');
          return `<div class="summary-section">
            <div class="summary-section-header">${section.toUpperCase()}</div>
            <div class="summary-content">${formattedContent}</div>
          </div>`;
        })
        .join('<br/>');
    }
    return '...';
  };

  return (
    <div className="flex p-4 min-h-[65vh] transitionary-summary">
      <div
        className="transitionary-content"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlContent(
            formatParsedSummary(parseSummary(summary))
          ),
        }}
      />
    </div>
  );
};
